import * as React from "react";
import { App } from "./app"
import { LoadBarGW } from "./LoadBarGW"
import { PADebug } from "./PADebug";

interface SearchFieldVm {
    app: App
}

interface ButtonState {
    hoverStateCross: string
    hoverStateSearch: string
}

/*  */
export class SearchField extends React.Component<SearchFieldVm, ButtonState> {
    constructor(props: SearchFieldVm) {
        super(props)
    }

    state: ButtonState = {
        hoverStateCross: "out",
        hoverStateSearch: "out"
    }

    // Sets the core's reference back to this view on initiation
    componentWillMount() {
        this.props.app.GetCore().ConnectSearchField(this)
    }

    // Passes on clicks to a handler within Core:
    onClick() {
    }

    // Handler for mouse out changes the state of the button, which only affects the graphics
    mouseOutHandler(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ hoverStateCross: "out", hoverStateSearch: "out"})
    }
    
    render() {
        var cathSearchImagePosition = (this.props.app.state.cathegoricSearch) ? ("-172px -0px") : ("-44px -0px")

        // The search area may be different things depending on circumstances such as what's been loaded and what type of search is selected
        var searchArea = <div></div>

        if (this.props.app.state.cathegoricSearch == false) {
            if (this.props.app.GetCore().isLoaded() == true) {
                searchArea = <input id="searchInput"
                    defaultValue={this.props.app.GetRecentSearchInput()}
                    onKeyDown={(par) => { this.props.app.searchFieldKeyHandler(par.key) }}
                    ref={(input) => {
                        if (input) this.props.app.SetSearchInput(input)
                    }}
                    style={{
                        position: 'relative',
                        width: "100%",
                        height: '20px',
                        top: '7px',
                        border: '0px'
                    }}>
                </input>
                this.props.app.GetCore().SetLoadBarMounted(false) // Blocks unwanted update attempts of the load bar (as it is not mounted)
            }
            else {
                // Chosen cathegory need not to be found within the selected pricebook for the load bar to be shown as it's not any cathegoric search.
                searchArea = <LoadBarGW app={this.props.app} allCath={true} />
                this.GetCore().SetLoadBarMounted(true) // Invites for load bar update requests
            }
        }
        else {
            if (this.GetCore().GetLastSelectedGroup() != "") {
                if (this.GetCore().isCurrentCathLoaded() == true) {
                    searchArea = <input id="searchInput"
                        defaultValue={this.props.app.GetRecentSearchInput()}
                        onKeyDown={(par) => { this.props.app.searchFieldKeyHandler(par.key) }}
                        ref={(input) => {
                            if (input) this.props.app.SetSearchInput(input)
                            // this.m_searchInput.setAttribute("value", this.m_recentSearchInput)
                        }}
                        style={{
                            position: 'relative',
                            width: "100%",
                            height: '20px',
                            top: '7px',
                            border: '0px'
                        }}>
                    </input>
                    this.GetCore().SetLoadBarMounted(false) // Blocks unwanted update attempts of the load bar (as it is not mounted)
                }
                else {
                    searchArea = <LoadBarGW app={this.props.app} allCath={false} />
                    this.GetCore().SetLoadBarMounted(true) // Invites for load bar update requests
                }
            }
            else {
                searchArea = <div style={{ position: "relative", top: "8px", left: "6px", color: "#AAAAAA" }}>(Ingen varegruppe valgt)</div>
                this.GetCore().SetLoadBarMounted(false) // Blocks unwanted update attempts of the load bar (as it is not mounted)
            }
        }
        
        var showCross = false

        if (this.props.app.GetSearchInput() != null) {
            showCross = (this.props.app.GetSearchInput().value == "") ? false : true
        }
        
        if (this.GetCore().isCurrentCathLoaded() == false) {
            showCross = false
        }
        
        var searchCrossButtonImagePosition = (this.state.hoverStateCross == "hover") ? ("-27px -72px") : ("-27px -38.15px")

        var searchBtnBGPosition = "-20px 0px"

        if (this.state.hoverStateSearch == "hover") {
            searchBtnBGPosition = "-20px -34px"
        }

        if (this.state.hoverStateSearch == "down") {
            searchBtnBGPosition = "-20px -68px"
        }

        var crossButton = < div
            onClick = { this.OnCrossClick.bind(this) }
            onMouseOut = { e => this.OnMouseOutCross() }
            onMouseOver = { e => this.OnMouseEnterCross() }
            onMouseDown = { e => this.OnMouseDownCross() }
            onMouseUp = { e => this.OnMouseUpCross() }
            style={{
                cursor: "pointer",
                backgroundImage: "url(images/searchCathegory.png)",
                backgroundPosition: searchCrossButtonImagePosition,
                height: "24px",
                width: "16px",
                position: "relative",
                top: '4px',
                left: '-97px'
            }}>
        </div >

        if (showCross == false) {
            crossButton = <div style = {{
                width: "16px",
                position: "relative",
                top: '4px',
                left: '-0px'
            }}></div>
        }
        
        {/*   Search...   */ }
        return <div onMouseOut={(e) => { this.mouseOutHandler(e) }}
            style={{
            height: "34px",
            width: "calc(100vw - 650px)",
            minWidth: "400px",
            display: "flex",
            direction: "row"
        }}>
            {/*   Margin Left   */}
            <div style={{
                    height: "34px",
                    width: "20px",
                    backgroundImage: "url(images/search.png)",
                    backgroundPosition: "0px 0px"
                }}>
            </div>

            {/*   Search button   */}
            <div className="tooltip" onClick={this.OnSearchBtnClick.bind(this)}
                onMouseOut={(e) => this.mouseOutHandler(e)}
                onMouseEnter={(e) => this.OnMouseEnterSearchBtn()}
                onMouseDown={(e) => this.OnMouseDownSearchBtn()}
                onMouseUp={(e) => this.OnMouseUpSearchBtn()}
                style={{
                    height: "34px",
                    width: "26px",
                    backgroundImage: "url(images/search.png)",
                    backgroundPosition: searchBtnBGPosition
                }}>
                <span className="tooltiptext">{"Søk Instillinger "}</span>
            </div>

            {/*   Search window  */}
            <div onClick={this.props.app.searchFieldClickHandler.bind(this.props.app)}
                style={{
                    height: "34px",
                    width: "calc(100% - 145px)",
                    backgroundImage: "url(images/searchWidenable.png)",
                    backgroundPosition: "0px 0px"
                }}>
                {searchArea}
            </div>
            
            {/*   Cathegoric Search?  */}
            <div
                onClick={this.props.app.searchCathegoryClickHandler.bind(this.props.app)}
                style={{
                    cursor: "pointer",
                    backgroundImage: "url(images/searchCathegory.png)",
                    backgroundPosition: cathSearchImagePosition,
                    height: "34px",
                    width: "80px",
                    position: "relative",
                    top: '0px',
                    left: '-0px'
                }}>
                <div
                    onClick={this.props.app.searchCathegoryClickHandler.bind(this.props.app)}
                    style={{
                        cursor: "pointer",
                        color: "white",
                        fontSize: "12px",
                        height: "34px",
                        width: "100px",
                        position: "relative",
                        top: '4px',
                        left: '22px'
                    }}>
                    Alle varegrupper
                                </div>
                <div
                    onClick={this.props.app.searchCathegoryClickHandler.bind(this.props.app)}
                    style={{
                        cursor: "pointer",
                        color: "white",
                        fontSize: "12px",
                        height: "34px",
                        width: "100px",
                        position: "relative",
                        top: '-17px',
                        left: '22px'
                    }}>
                    Valgt varegruppe
                </div>
            </div>

            {/*   Clear search cross button (at swapped position with cath search so that it won't affect the field length) */}
            {crossButton}
        </div>
    }

    private m_hoveredPosition: string

    private GetCore() {
        return this.props.app.GetCore()
    }

    OnCrossClick() {
        this.props.app.ResetSearchInput()
        this.props.app.GetCore().UpdateSearchFieldTimed()
        this.props.app.GetCore().SetFocusOnSearchInput()
        this.setState({ hoverStateCross: "out", hoverStateSearch: "out" })
    }

    OnMouseOutCross() {
        this.setState({ hoverStateCross : "out" })
    }

    OnMouseEnterCross() {
        this.setState({ hoverStateCross: "hover" })
    }

    OnMouseDownCross() {
        this.setState({ hoverStateCross: "down" })
    }

    OnMouseUpCross() {
        this.setState({ hoverStateCross: "hover" })
    }

    OnSearchBtnClick() {
        this.props.app.ResetSearchInput()
        this.props.app.GetCore().UpdateSearchFieldTimed()
        this.props.app.GetCore().SetFocusOnSearchInput()
        this.props.app.ScrollToTop()
        this.props.app.setState({ DisplayMode: this.props.app.DMode.searchSettings })
        this.setState({ hoverStateCross: "out", hoverStateSearch: "out" })
    }

    OnMouseOutSearchBtn() {
        this.setState({ hoverStateSearch: "out" })
    }

    OnMouseEnterSearchBtn() {
        if (this.props.app.state.DisplayMode != this.props.app.DMode.searchSettings) {
            this.setState({ hoverStateSearch: "hover" })
        }
        else {
            this.setState({ hoverStateSearch: "out" })
        }
    }

    OnMouseDownSearchBtn() {
        if (this.props.app.state.DisplayMode != this.props.app.DMode.searchSettings) {
            this.setState({ hoverStateSearch: "down" })
        }
        else {
            this.setState({ hoverStateSearch: "out" })
        }
    }

    OnMouseUpSearchBtn() {
        if (this.props.app.state.DisplayMode != this.props.app.DMode.searchSettings) {
            this.setState({ hoverStateSearch: "hover" })
        }
        else {
            this.setState({ hoverStateSearch: "out" })
        }
    }
}



// WEBPACK FOOTER //
// ./client/view/SearchField.tsx